<template>
  <div
    data-component="base-search-input"
    :class="componentState"
  >
    <input
      :value="search"
      :placeholder="placeholderText"
      :disabled="isDisabled"
      @input="onSearchInput"
    >

    <div
      data-button="icon-button"
      :class="componentState"
      @click="!isDisabled && !!search && $emit('search-change', '')"
    >
      <or-icon :icon="searchIcon" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrIconV3 as OrIcon } from '@onereach/ui-components-25';
import { SIZE_PROP } from '../../constants';

export default defineComponent({
  name: 'BaseSearchInput',
  components: { OrIcon },
  props: {
    search: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    size: SIZE_PROP,
    isDisabled: Boolean,
  },
  emits: ['search-change'],
  computed: {
    placeholderText() {
      return this.placeholder || this.$t('HITL.common.search.search');
    },
    searchIcon() {
      return this.search ? 'close' : 'search';
    },
    componentState() {
      return {
        [`is-${this.size}`]: true,
        'is-disabled': this.isDisabled,
      };
    },
  },
  methods: {
    onSearchInput(e: KeyboardEvent) {
      const search = (e.target as HTMLInputElement).value;
      this.$emit('search-change', search);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '../../styles';

[data-component='base-search-input'] {
  @include base-search-input;

  [data-button='icon-button'] {
    @include base-icon-button;
  }
}
</style>
